import {
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Typography,
  Autocomplete,
  Box,
  Button,
  Divider,
  Stepper,
  Step,
  StepLabel,
  LinearProgress,
  Alert,
  AlertTitle,
  Backdrop,
  CircularProgress,
} from "@mui/material";

import React, { useEffect, useMemo, useRef, useState } from "react";
import { connect } from "react-redux";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import {
  saveRequest,
  cancelEmployeeExitRequest,
  saveOrUpdateDraftRequest,
  submitFinalRequest,
} from "../../../store/exit/actions";

import {
  getUnitPositions,
  getEntitySectors,
} from "../../../store/structure/actions";

import { getAllPlanningEntities } from "../../../store/rbm/actions";
import moment from "moment";
import ConfirmationDialog from "../../common/components/ConfirmationDialog";
import { showError } from "../../toastify";
import {
  containsKeyInReplacements,
  replaceTextPlaceholders,
  textCapitalized,
} from "../../common/components/Utils";
import axios from "axios";
import CustomizedLetter from "../../documents/LetterFormat/CustomizedLetter";
import TextEditorComponent from "../../common/components/TextEditorComponent";
import ViewExitRequestAttachments from "../../exit/components/ViewExitRequestAttachments";
import CircleNotificationsIcon from "@mui/icons-material/CircleNotifications";
import InstitutionDetails from "../../training/components/InstitutionDetails";
import { ReactMultiEmail } from "react-multi-email";
import "react-multi-email/dist/style.css";
import { getLetterTemplates } from "../../../store/common/actions";

const steps = [
  { key: 0, name: "Fill Request Form" },
  { key: 1, name: "Fill Attachment(s)" },
  { key: 2, name: "Fill Request Letter" },
];

const InactiveButton = {
  float: "left",
  borderRadius: "8px",
  height: "35px",
  border: `1px solid rgb(7, 142, 206)`,
  display: "flex",
  color: "rgb(7, 142, 206)",
  alignItems: "center",
  fontSize: ".75rem",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  textTransform: "initial",
  "&:hover": {
    backgroundColor: "rgb(7, 142, 206)!important",
  },
};

const maxCharCount = 1500;
const NewExitRequestDialog = (props) => {
  const {
    loading,
    onWait,
    showEmployeeExitForm,
    setShowEmployeeExitForm,
    saveRequest,
    exitTypes,
    units,
    employeeExitRequest,
    cancelEmployeeExitRequest,
    getUnitPositions,
    positions,
    getEntitySectors,
    entitySectors,
    selectedEmployee,
    saveOrUpdateDraftRequest,
    submitFinalRequest,
    user,
    exitRequestAttachments,
    letterTemplates,
    getLetterTemplates,
    allPlanningEntities,
    getAllPlanningEntities,
  } = props;

  const isMountedRef = useRef(true);

  useEffect(() => {
    return () => {
      // Mark component as unmounted to avoid state updates on unmounted component
      isMountedRef.current = false;
    };
  }, []);

  useEffect(() => {
    if (!letterTemplates.length) getLetterTemplates();
  }, []);
  // console.log( letterTemplates);
  const [employee, setEmployee] = useState(
    selectedEmployee ? { ...selectedEmployee } : null
  );
  const [exitRequest, setExitRequest] = useState(
    employeeExitRequest ? { ...employeeExitRequest } : null
  );
  const [didRequestUpdate, setDidRequestUpdate] = useState(false);

  const [replacements, setReplacements] = useState({
    secondedPositionName: "",
    secondedInstitutionName: "",
    appointingReferLetterNo: "",
    appointingReferLetterDate: "",
    currentPositionName: "",
    currentEntityName: "",
    tranferredPositionName: "",
    tranferredEntityName: "",
    rotatedPositionName: "",
    committeeReportDate: "",
    giveTheDetailsOfFaults: "",
    periodFrom: "",
    serviceName: "",
    effectiveDate: null,
  });
  const [loadingPlanningEntities, setLoadingPlanningEntities] = useState(false);

  const [selectedPlanningEntity, setSelectedPlanningEntity] = useState(null);
  const [
    selectedAppointingAuthorityPlanningEntity,
    setSelectedAppointingAuthorityPlanningEntity,
  ] = useState(null);

  const [showConfirmSubmissionDialog, setShowConfirmSubmissionDialog] =
    useState(false);

  const [requestLetterTemplate, setRequestLetterTemplate] = useState(null);
  const [letterFooterContent, setLetterFooterContent] = useState(null);

  const [loadingEntitySectors, setLoadingEntitySectors] = useState(false);
  const [exitType, setExitType] = useState(null);

  const [localStorageKey, setLocalStorageKey] = useState({
    letter: `${employee?.id}-draftExitContent`,
    cc: `${employee?.id}-copiedInstitution`,
  });

  const [filteredSteps, setFilteredSteps] = useState([]);
  const [conditions, setConditions] = useState({
    isAttachmentRequired: false, // Change this to false or null to test removal of "Fill Attachment(s)"
    enableToGenerateLetter:false, // Change this to false to test removal of "Fill Request Letter"
  });
  const [enableToFillLetter, setEnableToFillLetter] = useState(true);

  const [entity, setEntity] = useState(null);
  const [unit, setUnit] = useState(null);
  const [position, setPosition] = useState(null);
  const [activeStep, setActiveStep] = useState(0);
  const [ccEmails, setCCEmails] = useState(
    exitRequest && !!exitRequest.cc ? JSON.parse(exitRequest?.cc || []) : []
  );

  const [entitySectorUnits, setEntitySectorUnits] = useState([]);

  const [employeeExitForm, setEmployeeExitForm] = useState({
    requestId: exitRequest?.id || null,
    employeeId: employee.id,
    employeePositionId: employee.employeePositionId,
    positionId: employee.positionId,
    toPositionId: exitRequest?.toPositionId || "",
    toUnitId: exitRequest?.toUnitId || "",
    toEntityId: exitRequest?.toEntityId || "",
    exitTypeId: exitRequest?.exitTypeId || "",
    effectiveDate: null,
    blacklistPeriod: 0,
    reason: exitRequest?.reason || "",
    letterBodyContent: exitRequest?.letterBodyContent || "",
    docLetterNo: exitRequest?.docLetterNo || "",
    copiedInstitutionContent: exitRequest?.copiedInstitutionContent || "",
    requestPlanningEntityId:
      exitRequest?.requestPlanningEntityId || employee.planningEntityId || "",
    appointingAuthorityPlanningEntityId:
      exitRequest?.appointingAuthorityPlanningEntityId ||
      employee.appointingAuthorityPlanningEntityId ||
      "",

    hiringModeId: employee?.hiringModeId || null,
    entitySectorId:
      exitRequest?.entitySectorId || employee?.entitySectorId || null,
    cc:
      exitRequest && !!exitRequest.cc ? JSON.parse(exitRequest?.cc || []) : [],
  });

  const uniquePlanningEntities = useMemo(() => {
    if (!Array.isArray(allPlanningEntities)) return [];
    const seen = new Set();
    return allPlanningEntities.filter((entity) => {
      if (!entity || !entity.id) return false;
      if (seen.has(entity.id)) return false;
      seen.add(entity.id);
      return true;
    });
  }, [allPlanningEntities]);

  useEffect(() => {
    if (exitRequest && !didRequestUpdate) {
      const unit =
        units.find(({ unitId }) => unitId === exitRequest.toUnitId) ||
        null;
      setUnit(unit);
    }
  }, [exitRequest, units, didRequestUpdate]);

  useEffect(() => {
    if (exitRequest && !didRequestUpdate) {
      const position =
        positions.find(({ id }) => id === exitRequest.toPositionId) || null;
      setPosition(position);
    }
  }, [exitRequest, positions, didRequestUpdate]);

  // Restore position from form data when going back or when positions array is available
  useEffect(() => {
    // Only restore if form has a toUnitId and positions array is available
    if (employeeExitForm.toUnitId && positions.length > 0 && !didRequestUpdate) {
      const foundPosition = positions.find(
        ({ id }) => id === employeeExitForm.toUnitId
      );
      if (foundPosition) {
        // Only set if position is null or different to avoid unnecessary updates
        setPosition((currentPosition) => {
          if (!currentPosition || currentPosition.id !== foundPosition.id) {
            return foundPosition;
          }
          return currentPosition;
        });
      }
    }
  }, [activeStep, employeeExitForm.toUnitId, positions, didRequestUpdate]);

  useEffect(() => {
    setActiveStep((exitRequest && exitRequest?.requestFormStepper) || 0);

    if (exitRequest && !!exitRequest.id && !didRequestUpdate) {
      const letterTemplatE = letterTemplates.find(
        ({ id }) => id === +exitRequest.letterTemplateId
      );
      setRequestLetterTemplate(letterTemplatE);

      setEmployeeExitForm((employeeExitForm) => ({
        ...employeeExitForm,
        requestId: exitRequest?.id || null,
        employeeId: exitRequest?.employeeId || null,
        employeePositionId: exitRequest.employeePositionId,
        positionId: exitRequest.positionId,
        toPositionId: exitRequest.toPositionId,
        toUnitId: exitRequest.toUnitId,
        toEntityId: exitRequest.toEntityId,
        tranferredEntityName: exitRequest.toEntityName,
        exitTypeId: exitRequest.exitTypeId,

        effectiveDate: exitRequest?.effectiveDate
          ? moment(exitRequest.effectiveDate).format("YYYY-MM-DD")
          : null,
        blacklistPeriod: exitRequest.blacklistPeriod,
        reason: exitRequest.reason,
        // letterBodyContent: exitRequest?.letterBodyContent || "",
        docLetterNo: exitRequest?.docLetterNo || "",
        ministryApproverInstitutionName:
          exitRequest?.ministryApproverInstitutionName || "",

        appointingAuthorityPlanningEntityId:
          exitRequest?.appointingAuthorityPlanningEntityId ||
          employee.appointingAuthorityPlanningEntityId ||
          "",

        entitySectorId:
          exitRequest?.entitySectorId || employee?.entitySectorId || null,
      }));
      // console.log(letterTemplatE);

      const entity =
        entitySectors.find(
          ({ entity }) => entity.id === exitRequest.toEntityId
        ) || null;

      // console.log(entity);
      setEntity(entity);

      if (!!employee?.isRISASharedStaff) {
        getEntitySectorUnits("1903000000-150000000000000000-11");
      }
      if (!employee?.isRISASharedStaff && exitRequest.toEntityId) {
        getEntitySectorUnits(exitRequest.toEntityId);
      }

      if (exitRequest.toUnitId)
        getUnitPositions(exitRequest.toUnitId);

      const exitType =
        exitTypes.find(({ id }) => id === exitRequest.exitTypeId) || null;
      setExitType(exitType);

      setConditions((conditions) => ({
        ...conditions,
        isAttachmentRequired: exitRequest.isAttachmentRequired,
        enableToGenerateLetter: exitRequest.enableToGenerateLetter,
      }));
    }
  }, [exitRequest, didRequestUpdate]);
  // console.log(employeeExitForm);
  //

  useEffect(() => {
    if (!uniquePlanningEntities.length) {
      let isMounted = true;
      getAllPlanningEntities((status) => {
        if (isMounted) {
          setLoadingPlanningEntities(status);
        }
      });
      return () => {
        isMounted = false;
      };
    }
  }, []);

  useEffect(() => {
    // console.log(position.appointingAuthorityPlanningEntityId);
    setSelectedAppointingAuthorityPlanningEntity(
      uniquePlanningEntities.find(
        ({ id }) => id === employeeExitForm?.appointingAuthorityPlanningEntityId
      ) || null
    );
  }, [
    employeeExitForm?.appointingAuthorityPlanningEntityId,
    uniquePlanningEntities,
  ]);


  const [errors, setErrors] = useState({
    exitTypeHasError: false,
    reasonHasError: false,
    effectiveDateHasError: false,
    entityHasError: false,
    unitHasError: false,
    positionHasError: false,
    referenceLetterIdError: false,
    referenceLetterDateError: false,
    draftContentMaxCharHasError: false,
    docLetterNoError: false,
    effectiveDateError: false,
    ccHasError: false,
  });

  const formValidator = () => {
    const error = {
      exitTypeHasError: false,
      reasonHasError: false,
      effectiveDateHasError: false,
      entityHasError: false,
      unitHasError: false,
      positionHasError: false,
      hasError: false,
    };

    if (!exitType) {
      error.exitTypeHasError = true;
      error.hasError = true;
    }

    if (!employeeExitForm.reason) {
      error.reasonHasError = true;
      error.hasError = true;
    }

    if (!employeeExitForm.effectiveDate) {
      error.effectiveDateHasError = true;
      error.hasError = true;
    }

    if (
      !!exitType &&
      exitType.id === 0 &&
      !employeeExitForm?.toUnitId
    ) {
      error.unitHasError = true;
      error.hasError = true;
    }

    if (
      !!exitType &&
      exitType.id === 0 &&
      !employeeExitForm?.toUnitId
    ) {
      error.positionHasError = true;
      error.hasError = true;
    }

    if (!!exitType && exitType.id === 6 && !employeeExitForm?.toEntityId) {
      error.entityHasError = true;
      error.hasError = true;
    }

    setErrors(error);
    // console.log(error);
    if (error.hasError) {
      showError("Fill the required fields");
      return true;
    }
    return false;
  };

  const getBlacklistPeriod = () =>
    +(exitType?.blacklistPeriod || 0) > 1
      ? (exitType?.blacklistPeriod || 0).toString() + " Years"
      : (exitType?.blacklistPeriod || 0).toString() + " Year";

  const onClose = () => {
    setExitRequest(null);
    setEmployeeExitForm({
      requestId: null,
      employeeId: "",
      employeePositionId: "",
      positionId: "",
      toUnitId: "",
      exitTypeId: "",
      effectiveDate: null,
      blacklistPeriod: 0,
      reason: "",
      letterBodyContent: "",
      docLetterNo: "",
      entitySectorId: "",
      copiedInstitutionContent: "",
      cc: [],
    });
    setShowConfirmationDialog(false);
    setShowEmployeeExitForm(false);
  };

  const onSave = () => {
    if (!exitType) {
      showError(`Please fill the exit type!`);
      return false;
    }

    if ([0, 6, 1007, 1008].includes(+exitType.id)) {
      if (!position) {
        showError(`No position selected.`);
        return false;
      }
      if (+position.numberOfVacantPosts === 0) {
        showError(
          `This position isn't available. there is (${position.numberOfVacantPosts}) number of vacant posts`
        );
        return false;
      }
    }
 

    const error = {
      exitTypeHasError: false,
      reasonHasError: false,
      effectiveDateHasError: false,
      hasError: false,
    };

    if (!employeeExitForm.reason) {
      error.reasonHasError = true;
      error.hasError = true;
    }

    if (!employeeExitForm.effectiveDate) {
      error.effectiveDateHasError = true;
      error.hasError = true;
    }
    setErrors(error);

    if (error.hasError) {
      showError("Fill the required fields");
      return true;
    }
    saveRequest(
      {
        ...employeeExitForm,
        effectiveDate: moment(employeeExitForm.effectiveDate).format(
          "YYYY-MM-DD"
        ),
        entityId: entity?.entity?.id || null,
        positionId: position?.id || null,
        exitTypeId: exitType.id,
        cc: ccEmails || [],
        requestPlanningEntityId:
          employee.planningEntityId ||
          selectedPlanningEntity?.id ||
          null,
        appointingAuthorityPlanningEntityId:
          employeeExitForm.appointingAuthorityPlanningEntityId ||
          selectedAppointingAuthorityPlanningEntity?.id ||
          null,
      },
      onClose
    );
  };

  const getNo = (idToSearch, data, key = "id") => {
    return data.findIndex((item) => item[key] === idToSearch) + 1;
  };

  useEffect(() => {
    // Filter steps based on the provided conditions.
    setFilteredSteps([
      ...steps.filter((step) => {
        if (step.key === 1 && !conditions.isAttachmentRequired) {
          return false; // Remove "Fill Attachment(s)" if isAttachmentRequired is false or null
        }
        if (step.key === 2 && !conditions.enableToGenerateLetter) {
          return false; // Remove "Fill Request Letter" if enableToGenerateLetter is false
        }
        return true;
      }),
    ]);
  }, [conditions, steps]);

  const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
    // Position restoration is handled by useEffect that watches activeStep and employeeExitForm.toUnitId
  };
  const getEntitySectorUnits = async (entitySectorId) => {
    try {
      setLoadingEntitySectors(true);
      const { data } = await axios.get(
        "/api/structure/entity-sector-units/" + entitySectorId
      );
      setEntitySectorUnits(data);
      setLoadingEntitySectors(false);
    } catch (error) {
      setLoadingEntitySectors(false);
      showError(error);
    }
  };
  const getEditorContent = (data) => {
    let draftContentMaxCharHasError = false;

    setEmployeeExitForm((prevForm) => ({
      ...prevForm,
      letterBodyContent: data.contents,
    }));

    if (!!data.isMaxChar) draftContentMaxCharHasError = true;

    setErrors({
      ...errors,
      draftContentMaxCharHasError: draftContentMaxCharHasError,
    });
  };
  const getEditorContent3 = (data) => {
    // console.log(data);
    setEmployeeExitForm((prevForm) => ({
      ...prevForm,
      copiedInstitutionContent: data.contents,
    }));
    // exitRequest.copiedInstitutionContent = data.contents;
  };
  const replacePlaceholders = (
    template,
    isVerifyContainsKeyInReplacement = false
  ) => {
    const replacement = {
      ...replacements,

      currentPositionName: employee?.positionName || "",
      currentEntityName: employee?.entityName || "",
      tranferredPositionName: position ? position.name : "",
      tranferredEntityName:
        exitType && exitType.id === 0
          ? employee?.entityName || ""
          : entity?.entity?.name || "",
      effectiveDate: moment(employeeExitForm.effectiveDate).format("LL"),
      requestDate: exitRequest?.createdOn ? moment(exitRequest.createdOn).format("LL") : moment().format("LL"),
    };
    setReplacements(replacement);
    if (!!isVerifyContainsKeyInReplacement)
      return containsKeyInReplacements(template, replacement);
    return replaceTextPlaceholders(template, replacement);
  };
  const handleSubmitDraftRequest = (disableAddStepper = false) => {
    if (!formValidator()) {
      if (!exitType) {
        showError(`Please fill the exit type!`);
        return false;
      }

      if ([0, 6, 1007, 1008].includes(+exitType.id)) {
        if (!position) {
          showError(`No position selected.`);
          return false;
        }
        if (+position.numberOfVacantPosts === 0) {
          showError(
            `This position isn't available. there is (${position.numberOfVacantPosts}) number of vacant posts`
          );
          return false;
        }
      }

      if (!employeeExitForm?.effectiveDate) {
        showError(`Effective Date is required`);
        return false;
      }

      if (!employeeExitForm?.reason) {
        showError(`Reason is required`);
        return false;
      }
  
      // console.log(employee, exitType, conditions);
      const requestFormStepper = !!disableAddStepper
        ? activeStep
        : activeStep + 1;
      if (!!conditions.enableToGenerateLetter) {
        setEnableToFillLetter(true);
      }

      if (
        !!conditions.isAttachmentRequired &&
        activeStep === 1 &&
        !exitRequestAttachments.length
      ) {
        showError("Attachment(s) is/are mandatory");
        return false;
      }

      window.localStorage.removeItem(localStorageKey.letter);
      window.localStorage.removeItem(localStorageKey.cc);

      if (conditions.enableToGenerateLetter) {
        employeeExitForm.letterBodyContent = replacePlaceholders(
          requestLetterTemplate?.letterBodyContent || ""
        );
        window.localStorage.setItem(
          localStorageKey.letter,
          employeeExitForm.letterBodyContent
        );
      }

      if (
        !!conditions.enableToGenerateLetter &&
        employee.isPositionSpecialistLevel === 1 &&
        employee.hasSpecialCaseOnExitRequest === 1 &&
        !employeeExitForm.appointingAuthEntitySectorId
      ) {
        showError(
          `Please set the appointing authority institution for the employee's position(${employee?.positionName}).`
        );
        return false;
      }
      // console.log(employeeExitForm);

      saveOrUpdateDraftRequest(
        {
          ...employeeExitForm,
          effectiveDate: moment(employeeExitForm.effectiveDate).format(
            "YYYY-MM-DD"
          ),
          requestId: exitRequest?.id || null,
          entityId: entity?.entity?.id || null,
          currentPositionId: employee.positionId || null,
          exitTypeId: exitType.id,
          cc: ccEmails || [],
          requestFormStepper: requestFormStepper,
          toPositionId: position?.id || null,
          toUnitId: unit?.unitId || null,
          letterBodyContent: employeeExitForm.letterBodyContent,
          employeeId: employee?.id || null,
          enableToGenerateLetter: conditions.enableToGenerateLetter,
          isAttachmentRequired: conditions.isAttachmentRequired,
          copiedInstitutionContent: employeeExitForm.copiedInstitutionContent,
          appointingAuthorityPlanningEntityId:
            employeeExitForm.appointingAuthorityPlanningEntityId ||
            selectedAppointingAuthorityPlanningEntity?.id ||
            selectedPlanningEntity?.id ||
            null,
          requestPlanningEntityId:
            employee?.planningEntityId ||
            selectedPlanningEntity?.id ||
            null,
          entitySectorId:
            employeeExitForm?.entitySectorId ||
            exitRequest?.entitySectorId ||
            employee?.entitySectorId ||
            null,
          hiringModeId: employee.hiringModeId,
        },
        (status, data) => {
          // console.log(status, data);
          // Avoid state updates if the component has been unmounted
          // if (!isMountedRef.current) return;

          if (!!status && !!data) {
            setDidRequestUpdate(true);
            setExitRequest((prevExitRequest) => ({ ...prevExitRequest, ...data }));
            // console.log(data);
            setActiveStep(requestFormStepper);
            setEmployeeExitForm((prevForm) => ({
              ...prevForm,
              requestId: data?.id || null,
              employeeId: data?.employeeId || null,
              employeePositionId: data.employeePositionId,
              positionId: data.positionId,
              toPositionId: data.toPositionId,
              toUnitId: data.toUnitId,
              toEntityId: data.toEntityId,
              tranferredEntityName: data.toEntityName,
              exitTypeId: data.exitTypeId,
              effectiveDate: moment(data.effectiveDate).format("YYYY-MM-DD"),
              blacklistPeriod: data.blacklistPeriod,
              reason: data.reason,
              letterBodyContent: data?.letterBodyContent || "",
              entitySectorId: data?.entitySectorId,
              cc: !!data.cc ? JSON.parse(data?.cc || []) : [],
              copiedInstitutionContent: data?.copiedInstitutionContent || "",
              appointingAuthorityPlanningEntityId:
                data?.appointingAuthorityPlanningEntityId,
              requestPlanningEntityId: data?.requestPlanningEntityId,

              docLetterNo: data.docLetterNo,
            }));
            setCCEmails(!!data.cc ? JSON.parse(data?.cc || []) : []);
            const entity =
              entitySectors.find(
                ({ entity }) => entity.id === data.toEntityId
              ) || null;
            setEntity(entity);
            const unit =
              units.find(({ unitId }) => unitId === data.toUnitId) ||
              null;
              // console.log(unit);
            setUnit(unit);
            // Only update position if data.toPositionId exists and is found in positions array
            // Otherwise, preserve the existing position to avoid clearing user's selection
            const positionIdToFind = data?.toPositionId;
            if (positionIdToFind) {
              const foundPosition = positions.find(
                ({ id }) => id === positionIdToFind
              );
              if (foundPosition) {
                setPosition(foundPosition);
              }
              // console.log(foundPosition);
              // If position not found in array, keep existing position (don't set to null)
              // This prevents clearing the user's selection if the position isn't in the positions array yet
            }
            // If no position ID in response, keep existing position (don't clear it)
            const exitType =
              exitTypes.find(({ id }) => id === data.exitTypeId) || null;
            setExitType(exitType);
            const letterTemplatE = letterTemplates.find(
              ({ id }) => id === +data.letterTemplateId
            );
            setRequestLetterTemplate(letterTemplatE);
            setConditions((conditions) => ({
              ...conditions,
              isAttachmentRequired: data.isAttachmentRequired,
              enableToGenerateLetter: data.enableToGenerateLetter,
            }));
          }
        }
      );
    }
  };
  const handleSubmitRequestAndAttachment = () => {
    if (!formValidator()) {
      if (!exitType) {
        showError(`Please fill the exit type!`);
        return false;
      }

      if ([0, 6, 1007, 1008].includes(+exitType.id)) {
        if (!position) {
          showError(`No position selected.`);
          return false;
        }
        if (+position.numberOfVacantPosts === 0) {
          showError(
            `This position isn't available. there is (${position.numberOfVacantPosts}) number of vacant posts`
          );
          return false;
        }
      }
      if (
        !exitRequestAttachments.length &&
        activeStep == 1 &&
        !!conditions.isAttachmentRequired
      ) {
        showError(`The supporting document(s) is/are required`);
        return false;
      }
  
      submitFinalRequest(
        {
          ...employeeExitForm,
          effectiveDate: moment(employeeExitForm.effectiveDate).format(
            "YYYY-MM-DD"
          ),
          requestId: exitRequest?.id || null,
          entityId: entity?.entity?.id || null,
          currentPositionId: employee.positionId || null,
          exitTypeId: exitType.id,
          cc: ccEmails || [],
          requestFormStepper: 0,
          toPositionId: position?.id || null,
          letterBodyContent: employeeExitForm.letterBodyContent,
          employeeId: employee?.id || null,
          enableToGenerateLetter: conditions.enableToGenerateLetter,
          isAttachmentRequired: conditions.isAttachmentRequired,
          copiedInstitutionContent: employeeExitForm.copiedInstitutionContent,
          hiringModeId: employee.hiringModeId,
          appointingAuthorityPlanningEntityId:
            employeeExitForm?.appointingAuthorityPlanningEntityId,
          requestPlanningEntityId: employee?.planningEntityId,
        },
        (status) => {
          // Modal will only close when user clicks close button
          // if (!isMountedRef.current) return;
          if (!!status) {
            window.localStorage.removeItem(localStorageKey.letter);
            window.localStorage.removeItem(localStorageKey.cc);
            // Modal will only close when user clicks close button
            onClose();
          }
        }
      );
    }
  };

  const handleSubmitRequestAndLetter = () => {
    if (!formValidator()) {
      if (!exitType) {
        showError(`Please fill the exit type!`);
        return false;
      }

      if ([0, 6, 1007, 1008].includes(+exitType.id)) {
        if (!position) {
          showError(`No position selected.`);
          return false;
        }
        if (+position.numberOfVacantPosts === 0) {
          showError(
            `This position isn't available. there is (${position.numberOfVacantPosts}) number of vacant posts`
          );
          return false;
        }
      }
      if (
        !!conditions.enableToGenerateLetter &&
        !letterFooterContent?.entity?.acronym
      ) {
        showError(`The institution acronym is missing!`);
        return false;
      }

      if (
        !!letterFooterContent &&
        !letterFooterContent?.entity?.institutionPhone
      ) {
        showError(`The institution phone number is required. Please update it`);
        return false;
      }

      if (
        letterFooterContent?.entity?.institutionPhone.includes("+25078XXXXXXX")
      ) {
        showError(
          `The institution phone number (${
            letterFooterContent?.entity?.institutionPhone || ""
          }) does not seem correct. Please update it.`
        );
        return false;
      }

      if (
        !!letterFooterContent &&
        !letterFooterContent?.entity?.institutionEmail
      ) {
        showError(`The institution email is required. Please update it`);
        return false;
      }

      if (letterFooterContent?.entity?.institutionEmail.includes("example")) {
        showError(
          `The institution email (${
            letterFooterContent?.entity?.institutionEmail || ""
          }) does not seem correct. Please update it.`
        );
        return false;
      }

      if (!!letterFooterContent && !letterFooterContent?.entity?.poBox) {
        showError(`The institution PO.Box is required. Please update it`);
        return false;
      }

      if (!!letterFooterContent && !letterFooterContent?.entity?.websiteUrl) {
        showError(`The institution website url is required. Please update it`);
        return false;
      }
      if (!!letterFooterContent && !letterFooterContent?.entity?.twitterPage) {
        showError(
          `The institution former(twitter) is required. Please update it`
        );
        return false;
      }

  
      //letterFooterContent

      const letterBodyContent =
        window.localStorage.getItem(localStorageKey.letter) ||
        employeeExitForm.letterBodyContent;

      const copiedInstitutionContent =
        window.localStorage.getItem(localStorageKey.cc) ||
        employeeExitForm.copiedInstitutionContent;

      if (!!conditions.enableToGenerateLetter && !letterBodyContent) {
        showError(`The letter content is required`);
        return false;
      }

      if (
        !!conditions.enableToGenerateLetter &&
        replacePlaceholders(letterBodyContent, true)
      ) {
        showError(`Please update a letter template`);
        return false;
      }
      // Regular expression to match one or more occurrences of <div><br /></div>
      const regex = new RegExp('(<div><br></div>)+');

      if (
        !!exitRequest.enableToGenerateLetter &&
        !!regex.test(copiedInstitutionContent) &&
        !!ccEmails.length
      ) {
        showError(
          `You've added the CC emails, but you didn't include the copied institution content.`
        );
        return false;
      }

      submitFinalRequest(
        {
          ...employeeExitForm,
          effectiveDate: moment(employeeExitForm.effectiveDate).format(
            "YYYY-MM-DD"
          ),
          requestId: exitRequest?.id || null,
          entityId: entity?.entity?.id || null,
          currentPositionId: employee.positionId || null,
          exitTypeId: exitType.id,
          cc: ccEmails || [],
          requestFormStepper: 0,
          toPositionId: position?.id || null,
          toUnitId: unit?.unitId || null,
          letterBodyContent: letterBodyContent,
          employeeId: employee?.id || null,
          enableToGenerateLetter: conditions.enableToGenerateLetter,
          isAttachmentRequired: conditions.isAttachmentRequired,
          copiedInstitutionContent: copiedInstitutionContent,
          appointingAuthorityPlanningEntityId:
            employeeExitForm?.appointingAuthorityPlanningEntityId,
          requestPlanningEntityId: employee?.planningEntityId,

          entitySectorId:
            employeeExitForm?.entitySectorId ||
            exitRequest?.entitySectorId ||
            employee?.entitySectorId ||
            null,
        },
        (status) => {
          // if (!isMountedRef.current) return;
          if (!!status) {
            window.localStorage.removeItem(localStorageKey.letter);
            window.localStorage.removeItem(localStorageKey.cc);
            // Modal will only close when user clicks close button
          }
        }
      );
    }
  };

  const handleLoadFooterContent = (data) => {
    // console.log(data);
    setLetterFooterContent(data);
  };
  // console.log({
  //   planningEntityId:employeeExitForm?.appointingAuthorityPlanningEntityId,
  //   requestPlanningEntityId: employeeExitForm?.requestPlanningEntityId,
  // });
  // console.log(uniquePlanningEntities);
  const isLoading =
    loading || onWait || loadingEntitySectors || loadingPlanningEntities;

  return (
    <>
      <Dialog
        onClose={(event, reason) => {
          // Only allow closing via close button, not by clicking outside or pressing ESC
          if (reason === "backdropClick" || reason === "escapeKeyDown") {
            return;
          }
        }}
        aria-labelledby="customized-dialog-title"
        open={showEmployeeExitForm}
        fullWidth
        maxWidth={"md"}
      >
        <Backdrop
          open={
            isLoading ||
            loadingEntitySectors ||
            loadingPlanningEntities ||
            loading ||
            onWait
          }
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: (theme) => theme.zIndex.modal + 1,
            backgroundColor: "rgba(255, 255, 255, 0.8)",
            borderRadius: 1,
          }}
        >
          <CircularProgress
            sx={{
              color: "rgb(7, 142, 206)",
            }}
            size={50}
            thickness={4}
          />
        </Backdrop>
        <DialogTitle className="text-primary">
          <Typography
            variant="overline"
            className="text-truncate"
            display="block"
            style={{ maxWidth: "70%" }}
          >
            <div className="row">
              <div className="col-12">
                <span className="ml-0 text-dark">
                  EXIT REQUEST {exitType ? " for " + exitType.name : ""} of
                </span>
                <span className="ml-0 px-1 fw-bold text-truncate text-primary">
                  {employee?.lastName} {employee?.firstName}
                </span>
              </div>
              <div className="col-12">
                <small
                  className="fw-bold text-truncate text-dark"
                  style={{ fontSize: "12px" }}
                >
                  {textCapitalized(employee?.entityName || "")}
                </small>
                <span
                  style={{ fontSize: "12px" }}
                  className="fas fa-angle-right ml-1"
                ></span>
                <small
                  className="ml-1 fw-bold text-truncate text-success"
                  style={{ fontSize: "12px" }}
                >
                  {textCapitalized(employee?.positionName || "")}
                </small>
              </div>
            </div>
          </Typography>

          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <span className="material-icons">close</span>
          </IconButton>

          {exitType && (
            <div className="mt-4">
              <Box sx={{ width: "100%", mt: 0 }}>
                <Stepper activeStep={activeStep}>
                  {filteredSteps.map((label, index) => {
                    const stepProps = {};
                    const labelProps = {};

                    // stepProps.completed = isCompleted;
                    return (
                      <Step key={label.name} {...stepProps}>
                        <StepLabel {...labelProps}>{label.name}</StepLabel>
                      </Step>
                    );
                  })}
                </Stepper>
              </Box>
            </div>
          )}
          {!!exitRequest && exitRequest?.statusName && (
            <Alert
              className="mt-2"
              variant="outlined"
              severity={"warning"}
              sx={{
                padding: "1px 15px 0px",
                width: "100%",
              }}
              icon={<CircleNotificationsIcon style={{ color: "#0099e8" }} />}
              action={
                <>
                  <Button
                    className="mt-0 mr-3"
                    onClick={() => setShowConfirmationDialog(true)}
                  >
                    Cancel this request
                  </Button>
                </>
              }
            >
              You can also cancel this {exitRequest.statusName} exit request!
            </Alert>
          )}
        </DialogTitle>
        <DialogContent className="pb-2">
          <Box sx={{ width: "100%", minHeight: "95vh" }} className="mt-1">
            <div className="py-3">
              {/* {!isEmpty(exitRequest) && ( */}
              <>
                {activeStep === 0 && (
                  <>
                    <div className="row px-3 mt-4">
                      <div className="col-12 mb-2">
                        {" "}
                        {(loading || loadingEntitySectors) && (
                          <LinearProgress />
                        )}
                      </div>
                      <div className="col-12">
                        <Autocomplete
                          size="small"
                          id="exitType"
                          defaultValue={null}
                          value={exitType}
                          options={(() => {
                            const groupId = selectedEmployee?.employeeGroupId;
                            const selectedEmployeeSectorId =
                              selectedEmployee?.entitySectorId;

                            const tmpExitTypes = [
                              ...exitTypes.filter(
                                (type) => ![1003, 13, 1005].includes(+type.id)
                              ),
                            ];
                            const contractTermination = exitTypes.find(
                              (type) => type.id === 13
                            );
                            const endMandate = exitTypes.find(
                              (type) => type.id === 1003
                            );

                            if ([3, 6, 5, 7].includes(groupId)) {
                              tmpExitTypes.push(contractTermination);
                            }

                            if ([2, 4].includes(groupId)) {
                              tmpExitTypes.push(endMandate);
                            }
                            const exitCarrierJudgesStaff = exitTypes.find(
                              (type) => type.id === 1005
                            );
                            if (
                              selectedEmployeeSectorId ===
                              "0500000000-040000000000000000-03"
                            ) {
                              tmpExitTypes.push(exitCarrierJudgesStaff);
                            }

                            return tmpExitTypes;
                          })()}
                          disabled={loading}
                          isOptionEqualToValue={(option, value) =>
                            option.id === value.id
                          }
                          onChange={(event, exitType) => {
                            setExitType(exitType || null);
                            setPosition(null);
                            setUnit(null);
                            setEntity(null);

                            const letterTemplatE = letterTemplates.find(
                              ({ id }) => id === +exitType?.letterTemplateId
                            );
                            setRequestLetterTemplate(letterTemplatE);

                            setConditions((prevForm) => ({
                              ...prevForm,
                              isAttachmentRequired:
                                exitType.isAttachmentRequired,
                              enableToGenerateLetter:!employee?.isAdministrativeDocumentDisabled &&
                                exitType.enableToGenerateLetter,
                            }));

                            setEmployeeExitForm({
                              ...employeeExitForm,
                              exitTypeId: exitType?.id || "",
                            });
                            if (exitType.id === 6 && !entitySectors.length)
                              getEntitySectors();
                            setErrors({ ...errors, exitTypeHasError: false });
                            // if (!!exitType && exitType.id === 6) getEntities();
                          }}
                          getOptionLabel={(option) =>
                            getNo(option?.id, exitTypes) + ":" + option?.name
                          }
                          renderOption={(props, exitType) => (
                            <Box component="li" key={exitType?.id} {...props}>
                              {getNo(exitType?.id, exitTypes)}: {exitType?.name}
                            </Box>
                          )}
                          renderInput={(params) => (
                            <TextField
                              required={true}
                              disabled={loading}
                              {...params}
                              label="Select type"
                              placeholder="Select type"
                              inputProps={{
                                ...params.inputProps,
                                autoComplete: "ExitType", // disable autocomplete and autofill
                              }}
                            />
                          )}
                        />

                        {errors.exitTypeHasError && (
                          <small className="text-danger mb-1">
                            Please, select exit type
                          </small>
                        )}
                      </div>

                      {!!exitType && exitType.id === 6 && (
                        <div className="col-12 mt-3">
                          <Autocomplete
                            size="small"
                            id="entity"
                            defaultValue={null}
                            value={entity}
                            options={entitySectors}
                            isOptionEqualToValue={(option, value) =>
                              option.id === value.id
                            }
                            onChange={(event, entity) => {
                              setEntity(entity || null);
                              setEmployeeExitForm({
                                ...employeeExitForm,
                                toEntityId: entity?.id || "",
                              });
                              setPosition(null);
                              setUnit(null);
                              setEntitySectorUnits([]);
                              getEntitySectorUnits(entity.id);

                              setErrors({ ...errors, entityHasError: false });
                            }}
                            getOptionLabel={(option) =>
                              (option?.entity?.name || "") +
                              (entity?.entity?.acronym
                                ? "(" + entity?.entity.acronym + ")"
                                : "")
                            }
                            renderOption={(props, entity) => (
                              <Box component="li" key={entity.id} {...props}>
                                {entity?.entity?.name || ""}
                                {entity?.entity?.acronym && (
                                  <>({entity?.entity.acronym})</>
                                )}{" "}
                                <span className="ml-1 badge badge-primary">
                                  {" "}
                                  {entity?.sector?.name || ""}{" "}
                                </span>
                              </Box>
                            )}
                            renderInput={(params) => (
                              <TextField
                                required={true}
                                {...params}
                                label="Select the institution to transfer"
                                placeholder="Select the institution to transfer"
                                inputProps={{
                                  ...params.inputProps,
                                  autoComplete: "entity", // disable autocomplete and autofill
                                }}
                              />
                            )}
                          />

                          {errors.entityHasError && (
                            <small className="text-danger mb-1">
                              Please, select the institution to transfer
                            </small>
                          )}
                        </div>
                      )}

                      {!!exitType && exitType.id === 6 && (
                        <div className="col-12 mt-3">
                          <Autocomplete
                            size="small"
                            id="unit"
                            defaultValue={null}
                            disabled={!entitySectorUnits.length}
                            value={unit}
                            options={entitySectorUnits}
                            isOptionEqualToValue={(option, value) =>
                              option.unitId === value.unitId
                            }
                            onChange={(event, unit) => {
                              setUnit(unit || null);
                              setPosition(null);
                              setEmployeeExitForm({
                                ...employeeExitForm,
                                toUnitId: unit?.unitId || "",
                                toPositionId: null,
                              });

                              setErrors({ ...errors, unitHasError: false });

                              if (!!unit) getUnitPositions(unit.unitId);
                            }}
                            getOptionLabel={(option) => option?.unitName}
                            renderOption={(props, unit) => (
                              <Box component="li" key={unit.id} {...props}>
                                {unit?.unitName}
                              </Box>
                            )}
                            renderInput={(params) => (
                              <TextField
                                required={true}
                                {...params}
                                label="Select unit to transfer"
                                placeholder="Select unit to transfer"
                                inputProps={{
                                  ...params.inputProps,
                                  autoComplete: "unit", // disable autocomplete and autofill
                                }}
                              />
                            )}
                          />

                          {errors.unitHasError && (
                            <small className="text-danger mb-1">
                              Please, Select unit to transfer
                            </small>
                          )}
                        </div>
                      )}

                      {!!exitType && [0, 1007, 1008].includes(exitType.id) && (
                        <div className="col-12 mt-3">
                          <Autocomplete
                            size="small"
                            id="unit"
                            defaultValue={unit}
                            value={unit}
                            options={units}
                            isOptionEqualToValue={(option, value) =>
                              option.unitId === value.unitId
                            }
                            onChange={(event, unit) => {
                              setUnit(unit || null);
                              setPosition(null);
                              setErrors({ ...errors, unitHasError: false });
                              setEmployeeExitForm({
                                ...employeeExitForm,
                                toUnitId: unit?.unitId || "",
                                toPositionId: null,
                              });
                              if (!!unit) getUnitPositions(unit.unitId);
                            }}
                            getOptionLabel={(option) => option?.unitName}
                            renderOption={(props, unit) => (
                              <Box component="li" key={unit.id} {...props}>
                                {unit?.unitName}
                              </Box>
                            )}
                            renderInput={(params) => (
                              <TextField
                                required={true}
                                {...params}
                                label="Select unit to transfer"
                                placeholder="Select unit to transfer"
                                inputProps={{
                                  ...params.inputProps,
                                  autoComplete: "unit", // disable autocomplete and autofill
                                }}
                              />
                            )}
                          />

                          {errors.unitHasError && (
                            <small className="text-danger mb-1">
                              Please,Select unit to transfer
                            </small>
                          )}
                        </div>
                      )}

                      {!!exitType &&
                        [0, 6, 1007, 1008].includes(exitType.id) && (
                          <div className="col-12 mt-3">
                            <Autocomplete
                              disabled={!positions.length}
                              size="small"
                              id="position"
                              defaultValue={null}
                              value={position}
                              options={positions.filter(
                                ({ id }) => id != employee.positionId
                              )}
                              isOptionEqualToValue={(option, value) =>
                                option.id === value.id
                              }
                              onChange={(event, position) => {
                                // console.log(position);
                                setPosition(position || null);

                                setEmployeeExitForm({
                                  ...employeeExitForm,
                                  toPositionId: position?.id || "",
                                });

                                setErrors({
                                  ...errors,
                                  positionHasError: false,
                                });
                              }}
                              getOptionLabel={(option) =>
                                option?.name +
                                (option.entitySectorId !==
                                (user?.selectedEntitySector?.id || null)
                                  ? `(${option?.entityName || ""})`
                                  : "")
                              }
                              renderOption={(props, position) => (
                                <>
                                  <Box
                                    component="li"
                                    key={position.id}
                                    {...props}
                                  >
                                    {position?.name}{" "}
                                    {position.entitySectorId !==
                                      (user?.selectedEntitySector?.id ||
                                        null) && (
                                      <span
                                        className="text-primary"
                                        style={{ fontSize: "12px" }}
                                      >
                                        ({position?.entityName})
                                      </span>
                                    )}
                                    <span className="badge badge-secondary ml-1">
                                      {position?.employeeGroupName}
                                    </span>{" "}
                                    <span className="badge badge-primary ml-1">
                                      ({position?.numberOfVacantPosts}
                                      )VacantPosts
                                    </span>
                                  </Box>
                                  <Divider />
                                </>
                              )}
                              renderInput={(params) => (
                                <TextField
                                  required={true}
                                  {...params}
                                  label="Select position to transfer"
                                  placeholder="Select position to transfer"
                                  inputProps={{
                                    ...params.inputProps,
                                    autoComplete: "position", // disable autocomplete and autofill
                                  }}
                                />
                              )}
                            />

                            {errors.positionHasError && (
                              <small className="text-danger mb-1">
                                Please, select position to transfer
                              </small>
                            )}
                          </div>
                        )}

                      {exitType && exitType?.blacklistPeriod > 0 && (
                        <div className="col-12 mt-3 ">
                          <TextField
                            style={{ backgroundColor: "#eee" }}
                            fullWidth
                            size="small"
                            name="blacklistPeriod"
                            label="Blacklist Period"
                            value={getBlacklistPeriod()}
                            disabled
                            onChange={(e) => {
                              setEmployeeExitForm({
                                ...employeeExitForm,
                                blacklistPeriod: e.target.value,
                              });
                            }}
                          />

                          <span className="badge badge-warning">
                            To be Blacklisted in {getBlacklistPeriod()}
                          </span>
                        </div>
                      )}
                      <div className="col-12 mt-3 ">
                        <TextField
                          fullWidth
                          size="small"
                          name="reason"
                          required={true}
                          multiline
                          rows={3}
                          value={employeeExitForm.reason}
                          label={`Exit reason for ${exitType?.name || ""}`}
                          placeholder={`Exit reason for ${
                            exitType?.name || ""
                          }`}
                          inputProps={{ maxLength: 459 }}
                          onChange={(e) => {
                            setEmployeeExitForm({
                              ...employeeExitForm,
                              reason: e.target.value,
                            });

                            setErrors({ ...errors, reasonHasError: false });
                          }}
                        />
                        {errors.reasonHasError && (
                          <small className="text-danger mb-1">
                            Please, type exit reason.
                          </small>
                        )}
                      </div>

                      <div className="col-12 mt-3 ">
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                          <DesktopDatePicker
                            label={
                              exitType?.id === 7
                                ? "Date of Death"
                                : "Effective End Date"
                            }
                            inputFormat="dd/MM/yyyy"
                            minDate={
                              +exitType?.effectiveInDays > 0
                                ? moment().subtract(
                                    exitType?.effectiveInDays,
                                    "days"
                                  )
                                : moment(
                                    user?.currentDate || new Date()
                                  ).subtract(30, "days")
                            }
                            maxDate={
                              +exitType?.effectiveInDays > 0
                                ? moment().add(
                                    exitType?.effectiveInDays,
                                    "days"
                                  )
                                : moment(user?.currentDate || new Date()).add(
                                    60,
                                    "days"
                                  )
                            }
                            value={employeeExitForm.effectiveDate}
                            onChange={(date) => {
                              setEmployeeExitForm({
                                ...employeeExitForm,
                                effectiveDate: date,
                              });

                              setErrors({
                                ...errors,
                                effectiveDateHasError: false,
                              });
                            }}
                            renderInput={(params) => (
                              <TextField
                                onKeyDown={(e) => e.preventDefault()}
                                required={true}
                                fullWidth
                                size="small"
                                {...params}
                              />
                            )}
                          />

                          {errors.effectiveDateHasError && (
                            <small className="text-danger mt-1">
                              {exitType?.id === 7
                                ? "Date of Death"
                                : "Effective End Date"}{" "}
                              is required{" "}
                            </small>
                          )}
                        </LocalizationProvider>
                        {employeeExitForm && employeeExitForm.effectiveDate && (
                          <span className="badge badge-primary mt-3">
                            This request will take effect on{" "}
                            {moment(employeeExitForm.effectiveDate).format(
                              "ll"
                            )}
                            , the effective date.
                          </span>
                        )}
                      </div>

                      {/* {!employeeExitForm.requestPlanningEntityId && (
                        <div className="col-12 mt-3">
                          <Autocomplete
                            fullWidth
                            size="small"
                            id="requestPlanningEntityId"
                            defaultValue={null}
                            value={selectedPlanningEntity}
                            options={uniquePlanningEntities}
                            isOptionEqualToValue={(option, value) =>
                              option.id === value.id
                            }
                            onChange={(event, row) => {
                              setSelectedPlanningEntity(row || null);
                              setEmployeeExitForm({
                                ...employeeExitForm,
                                requestPlanningEntityId: row?.id || "",
                              });
                            }}
                            getOptionLabel={(option) =>
                              option.name +
                                " / " +
                                option.entitySector?.sector.name || ""
                            }
                            renderOption={(props, row) => (
                              <Box component="li" {...props}>
                                {row.name}
                                {row.entitySector?.sector ? (
                                  <span className="ml-2 badge badge-primary">
                                    {row.entitySector?.sector.name}
                                  </span>
                                ) : (
                                  ""
                                )}{" "}
                                {row.id === employee.requestPlanningEntityId ? (
                                  <span className="ml-2 badge badge-success">
                                    Selected
                                  </span>
                                ) : (
                                  ""
                                )}
                              </Box>
                            )}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Request Planning Entity"
                                placeholder="Request Planning Entity"
                                inputProps={{
                                  ...params.inputProps,
                                  autoComplete: "requestPlanningEntityId", // disable autocomplete and autofill
                                }}
                              />
                            )}
                          />
                        </div>
                      )} */}
                      {!!conditions.enableToGenerateLetter && (
                        <div className="col-12 mt-3">
                          <Autocomplete
                            fullWidth
                            size="small"
                            id="appointingAuthorityPlanningEntityId"
                            defaultValue={null}
                            value={selectedAppointingAuthorityPlanningEntity}
                            options={uniquePlanningEntities}
                            isOptionEqualToValue={(option, value) =>
                              option.id === value.id
                            }
                            onChange={(event, row) => {
                              setSelectedAppointingAuthorityPlanningEntity(
                                row || null
                              );
                              setEmployeeExitForm({
                                ...employeeExitForm,
                                appointingAuthorityPlanningEntityId:
                                  row?.id || "",
                              });
                            }}
                            getOptionLabel={(option) =>
                              option.name +
                                " / " +
                                option.entitySector?.sector.name || ""
                            }
                            renderOption={(props, row) => (
                              <Box component="li" {...props}>
                                {row.name}
                                {row.entitySector?.sector ? (
                                  <span className="ml-2 badge badge-primary">
                                    {row.entitySector?.sector.name}
                                  </span>
                                ) : (
                                  ""
                                )}{" "}
                                {row.id ===
                                employee.appointingAuthorityPlanningEntityId ? (
                                  <span className="ml-2 badge badge-success">
                                    Selected
                                  </span>
                                ) : (
                                  ""
                                )}
                              </Box>
                            )}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Please select the appointing authority institution(if applicable)"
                                placeholder="Please select the appointing authority institution(if applicable)"
                                inputProps={{
                                  ...params.inputProps,
                                  autoComplete:
                                    "appointingAuthorityPlanningEntityId", // disable autocomplete and autofill
                                }}
                              />
                            )}
                          />

                          <Alert severity="info" className="mt-3">
                            <AlertTitle>Note</AlertTitle>
                            Please select the appointing authority institution
                            (if applicable). If the employee is being approved
                            by an appointing authority institution—for example,
                            if the employee works in the General Education
                            sector and is approved by the Ministry of
                            Education—then you should select the Ministry of
                            Education as the appointing authority institution.
                          </Alert>
                        </div>
                      )}
                    </div>
                  </>
                )}
                {activeStep === 1 &&
                  exitRequest &&
                  !!conditions.isAttachmentRequired && (
                    <>
                      <ViewExitRequestAttachments
                        exitTypeId={exitRequest.exitTypeId}
                        requestId={exitRequest && exitRequest.id}
                        canEdit={true}
                      />
                    </>
                  )}
                {((activeStep === 2 &&
                  exitRequest &&
                  !!conditions.enableToGenerateLetter &&
                  !!conditions.isAttachmentRequired) ||
                  (activeStep === 1 &&
                    exitRequest &&
                    !!conditions.enableToGenerateLetter &&
                    !conditions.isAttachmentRequired)) && (
                  <>
                    <div className="mx-2 w-full">
                      <CustomizedLetter
                        disableToEditLetterHeader={true}
                        enableToFillLetter={enableToFillLetter}
                        ccSelectForm={
                          <>
                            <strong>Enter CC Institution Email</strong>
                            <ReactMultiEmail
                              placeholder="Enter CC Institution Email"
                              emails={ccEmails}
                              onChange={(_emails) => {
                                setCCEmails(_emails);
                              }}
                              getLabel={(email, index, removeEmail) => {
                                return (
                                  <div data-tag key={index}>
                                    {email}
                                    <span
                                      data-tag-handle
                                      onClick={() => removeEmail(index)}
                                    >
                                      ×
                                    </span>
                                  </div>
                                );
                              }}
                            />
                          </>
                        }
                        ccEmails={ccEmails}
                        docLetterNo={exitRequest?.docLetterNo || ""}
                        signContent={
                          <>
                            <InstitutionDetails
                              headOfInstitution={{
                                isDelegated: exitRequest?.isDelegated || false,
                                isMinster: exitRequest?.isMinster || false,
                                firstName:
                                  exitRequest?.ministryApproverFirstName,
                                lastName: exitRequest?.ministryApproverLastName,
                                institutionName:
                                  exitRequest?.ministryApproverInstitutionName,
                                positionName:
                                  exitRequest?.ministryApproverPositionName,
                                institutionName:
                                  exitRequest?.ministryApproverInstitutionName ||
                                  "",
                                canAddInstitutionName:
                                  exitRequest?.ministryApproverCanAddInstitutionName ||
                                  false,
                              }}
                              userSignature={null}
                            />
                          </>
                        }
                        subTitle={
                          "Dear " +
                          (employee.lastName.toUpperCase() +
                            " " +
                            employee.firstName)
                        }
                        recipientContent={
                          <>
                            {employee.lastName.toUpperCase() +
                              " " +
                              employee.firstName}{" "}
                            <br />
                            Tel: {employee.phoneNumber} <br />
                            Email: {employee.email} <br />
                          </>
                        }
                        // entitySectorId={
                        //   employeeExitForm?.appointingAuthorityPlanningEntityId ||
                        //   employeeExitForm?.requestPlanningEntityId ||
                        //   null
                        // }
                        planningEntityId={
                          employeeExitForm?.appointingAuthorityPlanningEntityId ||
                          employeeExitForm?.requestPlanningEntityId ||
                          null
                        }
                        letterBodyContentInput={
                          <>
                            <TextEditorComponent
                              id="editor-exit-textarea"
                              options={{
                                autoSave: false,
                                localStorageKey: localStorageKey.letter,
                                maxCharCount: maxCharCount,
                                defaultValue: !!window.localStorage.getItem(
                                  localStorageKey.letter
                                )
                                  ? window.localStorage.getItem(
                                      localStorageKey.letter
                                    )
                                  : employeeExitForm.letterBodyContent,
                              }}
                              onEditorChange={(data) => {
                                getEditorContent(data);
                              }}
                            />
                          </>
                        }
                        letterBodyContent={
                          employeeExitForm?.letterBodyContent || ""
                        }
                        title={requestLetterTemplate?.subject || ""}
                        copiedInstitutionContentInput={
                          <>
                            <br />
                            <strong>Enter CC Institution Name</strong>
                            <TextEditorComponent
                              id="editor-textarea6"
                              options={{
                                autoSave: false,
                                height: "auto",
                                localStorageKey: localStorageKey.cc,
                                maxCharCount: maxCharCount,
                                defaultValue: !!window.localStorage.getItem(
                                  localStorageKey.cc
                                )
                                  ? window.localStorage.getItem(
                                      localStorageKey.cc
                                    )
                                  : employeeExitForm.copiedInstitutionContent,
                              }}
                              onEditorChange={(data) => {
                                getEditorContent3(data);
                              }}
                            />
                          </>
                        }
                        copiedInstitutionContent={
                          employeeExitForm?.copiedInstitutionContent || ""
                        }
                        loadFooterContent={(data) =>
                          handleLoadFooterContent(data)
                        }
                      />
                    </div>
                  </>
                )}
              </>
              {/* )} */}
            </div>
          </Box>
        </DialogContent>
        {/* {!isEmpty(exitRequest) && ( */}
        <DialogActions className="d-flex justify-content-center pb-3">
          {activeStep > 0 &&
            exitType &&
            (!!conditions.enableToGenerateLetter ||
              !!conditions.isAttachmentRequired) && (
              <Button
                style={{
                  ...InactiveButton,
                  // padding: theme.spacing(1.5, 1.5, 1.5, 1.5),
                  float: "right",
                }}
                size="md"
                disabled={activeStep === 0 || loading}
                onClick={handleBack}
              >
                Back
              </Button>
            )}
          {exitType &&
            (!!conditions.enableToGenerateLetter ||
              !!conditions.isAttachmentRequired) && (
              <Box sx={{ flex: "1 1 auto" }} />
            )}

          {/* WHEN NO FILE REQUIRED AND NO LETTER REQUIRED */}
          {exitType &&
            !conditions.enableToGenerateLetter &&
            !conditions.isAttachmentRequired && (
              <>
                <Button
                  color="success"
                  variant="contained"
                  disabled={loading || onWait || !exitType}
                  onClick={onSave}
                  size="md"
                >
                  {onWait ? "Wait.." : <>Submit</>}
                </Button>
              </>
            )}
          {/* WHEN FILE REQUIRED OR LETTER REQUIRED, BUT ONE OF THEM SHOULD BE NOT REQUIRED */}
          {/* {exitType &&
              [0].includes(activeStep) &&
              (!!exitType.enableToGenerateLetter ||
                !!exitType.isAttachmentRequired) && (
                <Button
                  disabled={loading || onWait || !exitType}
                  onClick={() => handleSubmitDraftRequest(false)}
                  color={"primary"}
                  variant="contained"
                  size="md"
                >
                  {onWait ? "Wait.." : <> Next</>}
                </Button>
              )} */}
          {/* WHEN FILE REQUIRED AND LETTER REQUIRED BUT ON STEP 1 OR 2 */}
          {((activeStep === 0 &&
            !!exitType &&
            !conditions.enableToGenerateLetter) ||
            ([0, 1].includes(activeStep) &&
              !!exitType &&
              !!conditions.enableToGenerateLetter)) && (
            <Button
              disabled={loading || onWait || !exitType}
              onClick={() => handleSubmitDraftRequest(false)}
              color={"primary"}
              variant="contained"
              size="md"
            >
              {onWait ? "Wait.." : <> Next</>}
            </Button>
          )}

          {/* SUBMIT REQUEST WITH ATTACHMENTS BUT NO LETTER REQUIRED */}
          {conditions &&
            activeStep === 1 &&
            !conditions.enableToGenerateLetter && (
              <>
                <Button
                  disabled={loading || onWait || !exitType}
                  onClick={handleSubmitRequestAndAttachment}
                  color={"success"}
                  variant="contained"
                  size="md"
                >
                  {onWait ? "Wait.." : <> Submit</>}
                </Button>
              </>
            )}
          {/* SUBMIT REQUEST WHEN FILES REQUIRED AND LETTER ALSO WHEN FILES NOT REQUIRE BUT LETTER REQUIRED */}
          {activeStep === 2 &&
            conditions &&
            !!conditions.enableToGenerateLetter && (
              <>
                <Button
                  disabled={loading || onWait || !exitType}
                  onClick={() => setShowConfirmSubmissionDialog(true)}
                  color={"success"}
                  variant="contained"
                  size="md"
                >
                  {onWait ? "Wait.." : <> Submit</>}
                </Button>
              </>
            )}
        </DialogActions>
        {/* )} */}
      </Dialog>

      {showConfirmSubmissionDialog && (
        <ConfirmationDialog
          confirmationDialog={showConfirmSubmissionDialog}
          message={`Are you sure you want to Submit the exit request for ${
            employee?.lastName + " " + employee?.firstName
          }?`}
          setConfirmationDialog={setShowConfirmSubmissionDialog}
          onYes={() => {
            handleSubmitRequestAndLetter();
          }}
        />
      )}

      {showConfirmationDialog && (
        <ConfirmationDialog
          confirmationDialog={showConfirmationDialog}
          message={`Are you sure you want to cancel the exit request for ${
            employee?.lastName + " " + employee?.firstName
          }?`}
          setConfirmationDialog={setShowConfirmationDialog}
          onYes={() => {
            if (exitRequest && exitRequest.enableToFillLetter) {
              window.localStorage.removeItem(localStorageKey.letter);
              window.localStorage.removeItem(localStorageKey.cc);
            }
            cancelEmployeeExitRequest(exitRequest, onClose);
          }}
        />
      )}
    </>
  );
};

const mapStateToProps = ({
  loading,
  onWait,
  exitTypes,
  employeeExitRequest,
  units,
  positions,
  entitySectors,
  user,
  exitRequestAttachments,
  letterTemplates,
  allPlanningEntities,
}) => {
  return {
    loading,
    onWait,
    exitTypes,
    employeeExitRequest,
    units,
    positions,
    entitySectors,
    user,
    exitRequestAttachments,
    letterTemplates,
    allPlanningEntities,
  };
};
export default connect(mapStateToProps, {
  saveRequest,
  saveOrUpdateDraftRequest,
  cancelEmployeeExitRequest,
  getUnitPositions,
  getEntitySectors,
  submitFinalRequest,
  getLetterTemplates,
  getAllPlanningEntities,
})(NewExitRequestDialog);
